import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IConfigReformaPensiones } from '@interfaces/config-reforma-pensiones.interface';
import { Util } from '@shared/common/utils/util';
import { firstValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';
import { IBeneficiosReforma } from '../../shared/interfaces/beneficios-reforma.response.interface';

@Injectable({
  providedIn: 'root'
})
export class ReformaPensionesService {

    private beneficiosReformaPensionesPromise: Promise<IBeneficiosReforma[]> | null = null;
    private calendarioReformaPensionesPromise: Promise<IConfigReformaPensiones> | null = null;
    private lastToken: string | null = null;

  constructor(private readonly http: HttpClient, private readonly util: Util) { }

  async getBeneficiosReformaPensiones(token: string): Promise<IBeneficiosReforma[]>  {
     if (this.beneficiosReformaPensionesPromise && this.lastToken === token) {
          return this.beneficiosReformaPensionesPromise;
        }
          const url = `${environment.BASE_BACKEND}/client/beneficios-reforma`;
          const headers = this.util.getHeaders(token);
    
          this.lastToken = token;
        
         this.beneficiosReformaPensionesPromise = firstValueFrom(this.http.post<IBeneficiosReforma[]>(url, null, { headers }))
          .finally(() => {
            // Limpiar la promesa después de que se complete (éxito o error)
            this.beneficiosReformaPensionesPromise = null;
            this.lastToken = null;
          });
    
        return this.beneficiosReformaPensionesPromise;
  }

   async getCalendarioReformaPensiones(token: string): Promise<IConfigReformaPensiones>  {
     if (this.calendarioReformaPensionesPromise && this.lastToken === token) {
          return this.calendarioReformaPensionesPromise;
        }
          const url = `${environment.BASE_BACKEND}/client/calendario-reforma-pensiones`;
          const headers = this.util.getHeaders(token);
    
          this.lastToken = token;
        
         this.calendarioReformaPensionesPromise = firstValueFrom(this.http.post<IConfigReformaPensiones>(url, null, { headers }))
          .finally(() => {
            // Limpiar la promesa después de que se complete (éxito o error)
            this.calendarioReformaPensionesPromise = null;
            this.lastToken = null;
          });
    
        return this.calendarioReformaPensionesPromise;
  }
}
